import React from 'react';
import {
  Box,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Container,
  Link,
} from '@mui/material';
import Typo from './Typo';
import { useTranslation } from 'react-i18next';

const Solutions = ({
  title,
}) => {
  const { t } = useTranslation();

  const solutions = [
    {
      title: t('solutions1Title'),
      description: t('solutions1Description'),
      image: '/assets/chekup/repair-shop.png',
      link: t('solutions1Link'),
    },
    {
      title: t('solutions2Title'),
      description: t('solutions2Description'),
      image: '/assets/chekup/parts-store.png',
      link: t('solutions2Link'),
    },
    {
      title: t('solutions3Title'),
      description: t('solutions3Description'),
      image: '/assets/chekup/windshield.png',
      link: t('solutions3Link'),
    },
    {
      title: t('solutions4Title'),
      description: t('solutions4Description'),
      image: '/assets/chekup/truck-repair.png',
      link: t('solutions4Link'),
    },
    {
      title: t('solutions5Title'),
      description: t('solutions5Description'),
      image: '/assets/chekup/detailing.png',
      link: t('solutions5Link'),
    },
    {
      title: t('solutions6Title'),
      description: t('solutions6Description'),
      image: '/assets/chekup/other-repair.png',
      link: t('solutions6Link'),
    },
  ];

  return (
    <Container maxWidth={false}
      sx={{
        maxWidth: '1440px',
        px: { xs: 2, md: 4 },
        mt: 10,
        mb: 10,
      }}>
      <Typo
        variant="h2"
        text={title || t('solutionsTitle')}
        sx={{
          textAlign: 'center',
          mb: 8,
        }}
      />

      <Grid container spacing={3} sx={{ px: { xs: 5, md: 0 } }}>
        {solutions.map((solution, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                borderRadius: '8px',
                overflow: 'hidden',
                boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08)',
                transition: 'transform 0.2s, box-shadow 0.2s',
              }}
            >
              <CardMedia
                component="img"
                height={180}
                image={solution.image}
                alt={solution.title}
                sx={{
                  objectFit: 'cover',
                }}
              />
              <CardContent sx={{ flexGrow: 1, p: 3 }}>
                <Typo
                  variant="h4"
                  text={solution.title}
                  sx={{
                    mb: 1,
                  }}
                />
                <Typo
                  variant="body2"
                  text={solution.description}
                  sx={{
                    mb: 2,
                  }}
                />

              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Solutions;
